import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet } from "./axiosFunctions";

const getVendorMasterAllUrl                                 = '/api/admin/vendor/getVendorMasterAll';
const postVendorMasterUrl                                   = '/api/admin/vendor/postVendorMaster';

const getVendorUsersByVendorIDUrl                           = (vendorID) => `/api/admin/vendor/getVendorUsersByVendorID/${vendorID}`;
const postVendorUserUrl                                     = '/api/admin/vendor/postVendorUser';

const getVendorTemplatesByVendorIDUrl                       = (vendorID) => `/api/admin/vendor/getVendorTemplateByID/${vendorID}`;
const getBookingMastersUrl                                  = '/api/admin/vendor/getBookingMasters';
const getBookingTemplatesUrl                                = (vendorId, masterid, starttype) => `/api/admin/vendor/getBookingTemplates?vendorid=${vendorId}&masterid=${masterid}&starttype=${starttype}`;
const saveVendorTemplatesUrl                                = '/api/admin/vendor/postVendorTemplate';


export const getVendorMasterAll = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getVendorMasterAllUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postVendorMaster = async (vendorDetails) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        postVendorMasterUrl,
        { vendorDetails },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postVendorUser = async (vendorUserDetails) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        postVendorUserUrl,
        { vendorUserDetails },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getVendorUsersByVendorID = async (vendorID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getVendorUsersByVendorIDUrl(vendorID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getVendorTemplatesByVendorID = async (vendorID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getVendorTemplatesByVendorIDUrl(vendorID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const saveVendorTemplates = async (templates) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        saveVendorTemplatesUrl,
        { templates },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getBookingMasters = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getBookingMastersUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getBookingTemplates = async (vendorId, masterid, starttype) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getBookingTemplatesUrl(vendorId, masterid, starttype),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};


//#region Vendor Fee Calendar

const getVendorFeeCalendarByVendorIDUrl     = (vendorID) => `/api/admin/vendor/getVendorFeeCalendarByVendorID/${vendorID}`;
const postVendorFeeCalendarUrl              = '/api/admin/vendor/postVendorFeeCalendar';
const updateVendorFeeCalendarStatusUrl      = '/api/admin/vendor/updateVendorFeeCalendarStatus';

export const getVendorFeeCalendarByVendorID = async (vendorID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getVendorFeeCalendarByVendorIDUrl(vendorID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postVendorFeeCalendar = async (calendar, fees) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        postVendorFeeCalendarUrl,
        { calendar, fees },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const updateVendorFeeCalendarStatus = async (id, isActive) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        updateVendorFeeCalendarStatusUrl,
        { feeCalendarDetails: { ID: id, IsActive: isActive } },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

//#endregion


//#region Vendor Booking Publish (clone of TeeTime publish)

const getVendorPublishPageDataUrl     = '/api/admin/vendor/getVendorPublishPageData';
const getVendorPublishMasterDataUrl   = '/api/admin/vendor/getVendorPublishMasterData';
const postVendorTeeTimePublishUrl     = '/api/admin/vendor/postVendorTeeTimePublish';

export const getVendorPublishPageData = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        getVendorPublishPageDataUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getVendorPublishMasterData = async (masterId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosGet(
        `${getVendorPublishMasterDataUrl}/${masterId}`,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postVendorTeeTimePublish = async (data) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(
        postVendorTeeTimePublishUrl,
        { ...data },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

//#endregion

